"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    downloadSvgFill: {
        fill: function (data) { return data.color; },
    },
};
//# sourceMappingURL=download.theme.js.map